import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import posthog from 'posthog-js';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) {
      posthog.capture('faq_opened', {
        question
      });
    }
  };
  return <div className="w-full bg-white border border-line rounded-[16px] overflow-hidden" data-id="element-46">
      <button type="button" onClick={toggle} aria-expanded={open} className="w-full flex items-center justify-between text-left px-6 py-5 gap-4" data-id="element-47">
        <span className="font-sans font-semibold text-[17px] text-ink leading-snug" data-id="element-48">
          {question}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex-shrink-0 text-ink-soft" data-id="element-49">
          <ChevronDownIcon size={20} data-id="element-50" />
        </motion.span>
      </button>

      <AnimatePresence initial={false} data-id="element-51">
        {open && <motion.div key="content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden" data-id="element-52">
            <p className="font-sans font-normal text-[16px] text-ink-soft leading-[1.6] px-6 pb-4 whitespace-pre-line" data-id="element-53">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}